import React, { useState, Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import {
  CheckCircleIcon,
  PlusCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useEffect } from "react";
import Button from "../button";
import IconButton from "../iconButton";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const CustomEventDropdown = ({
  icon: Icon,
  options,
  selectedProfession,
  classes,
  textClasses,
  leftIconClasses,
  rightIconClasses,
  menuClasses,
  name,
  formik,
  handleChange,
  newEvent,
  setNewEvent,
  handleEvent,
}) => {
  const [selectedOption, setSelectedOption] = useState();

  useEffect(() => {
    options?.length > 0 &&
      setSelectedOption(selectedProfession?.name ?? options[0]);
  }, [options, selectedProfession]);

  const handleOptionClick = (option) => {
    setSelectedOption({ name: option.name, color: option.color });
    // formik?.setFieldValue(name, option.name);
    // handleChange && handleChange(option);
  };

  return (
    <div className="w-full md:w-auto">
      <div className={`${classes} relative`}>
        <Menu as="div" className="text-left w-full">
          <div className="flex items-center">
            {!newEvent ? (
              <Menu.Button className={`${textClasses}`}>
                <span
                  className={`w-2.5 h-2.5 border-solid rounded-[50%] bg-[${selectedOption?.color}]`}
                ></span>
                {selectedOption?.name}
                <div className="absolute inset-y-0 right-[14px] flex items-center gap-2 pl-[10px] border-l border-solid border-[#CCD0D4] h-6 my-auto">
                  <ChevronDownIcon
                    className={`${rightIconClasses}`}
                    aria-hidden="true"
                  />
                </div>
              </Menu.Button>
            ) : (
              <div className={`${textClasses}`}>
                <span className="w-2.5 h-2.5 border-solid rounded-[50%] bg-[#16CA7C]"></span>
                <input
                  type="text"
                  placeholder="Text"
                  className="text-sm md:text-lg font-medium leading-[160%] text-customGray placeholder:text-[#A7AFB7]"
                />
                <div className="absolute inset-y-0 right-[14px] flex items-center gap-2 pl-[10px] border-l border-solid border-[#CCD0D4] h-6 my-auto">
                  <CheckCircleIcon
                    className="text-green-500 w-6 h-6 cursor-pointer"
                    aria-hidden="true"
                  />
                  <XMarkIcon
                    onClick={() => setNewEvent(false)}
                    className="text-red-500 w-6 h-6 cursor-pointer"
                    aria-hidden="true"
                  />
                </div>
              </div>
            )}
          </div>

          {!newEvent && (
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-y-95"
              enterTo="transform opacity-100 scale-y-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-y-100"
              leaveTo="transform opacity-0 scale-y-95"
            >
              <Menu.Items className={`${menuClasses}`}>
                <div className="pt-3 pb-6 px-5">
                  {options.map((option, index) => (
                    <Menu.Item key={option}>
                      {({ active }) => (
                        <div
                          className="flex items-center gap-3 py-3 border-b border-[#F1F4F6] text-sm cursor-pointer"
                          onClick={() => handleOptionClick(option)}
                        >
                          <span
                            className={`block w-2.5 h-2.5 border-solid rounded-[50%] bg-[${option.color}]`}
                          ></span>
                          <a
                            id={`option-${index}`}
                            className={classNames(
                              active ? "text-customGray" : "text-customGray",
                              "text-sm md:text-lg font-medium leading-[160%]"
                            )}
                          >
                            {option.name}
                          </a>
                        </div>
                      )}
                    </Menu.Item>
                  ))}
                  <IconButton
                    title="Add New"
                    classes="text-sm md:text-lg font-bold leading-[160%] text-primary inline-flex items-center gap-1.5 mt-4 capitalize cursor-pointer"
                    icon={PlusCircleIcon}
                    iconClasses="w-6 h-6"
                    onClick={handleEvent}
                  />
                </div>
              </Menu.Items>
            </Transition>
          )}
        </Menu>
      </div>
      {formik?.touched[name] && formik?.errors[name] && (
        <p className="text-red-500 text-xs leading-[160%] font-bold mb-4 -mt-4 block">
          {formik?.touched[name] && formik?.errors[name]}
        </p>
      )}
    </div>
  );
};

export default CustomEventDropdown;
